"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("form-true-false", require("./elements/TrueFalse.vue").default);
Vue.component("form-textbox", require("./elements/TextBox.vue").default);
Vue.component("form-range", require("./elements/Range.vue").default);
Vue.component("form-droplist", require("./elements/Droplist.vue").default);
Vue.component("form-radio", require("./elements/Radio.vue").default);
Vue.component("form-checkbox", require("./elements/Checkbox.vue").default);

exports.default = {
  props: ["question", "unique", "test", "value", "autosavedResults"],

  computed: {
    name: function name() {
      var arr = _.concat(this.unique, []);
      var first = arr.shift();

      return first + "[" + arr.join("][") + "]";
    }
  },

  methods: {
    update: function update() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ["update"].concat(_toConsumableArray(args)));
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/Question.vue
// module id = lpJ7
// module chunks = 0 1